import { TFunction } from 'i18next';
import { camelCase } from 'lodash-es';

import { Filters } from '~/features/catalog/models/filter';

const TYPE_TITLE_KEYS: Record<string, string> = {
  course: 'catalog.allCourses',
  'nanodegree program': 'catalog.allNanodegrees',
  masters: 'catalog.allMastersPrograms',
};

/**
 * Heading for the challenger catalog: the active search wins, then a title built from the active
 * filters, then the "All Programs & Courses" default.
 */
export function getCatalogSearchTitle({
  searchValue,
  selectedFilters,
  t,
}: {
  searchValue?: string;
  selectedFilters: Filters;
  t: TFunction;
}) {
  const trimmedSearchValue = searchValue?.trim();
  if (trimmedSearchValue) {
    return t('catalog.searchResultsFor', { query: trimmedSearchValue });
  }

  const filterNames = [
    selectedFilters.scope,
    selectedFilters.price,
    selectedFilters.difficulty,
    selectedFilters.school,
  ].flatMap((filterValues) =>
    filterValues?.[0] && filterValues[0] !== 'all' ? [t(`catalog.filters.option.${camelCase(filterValues[0])}`)] : []
  );
  const singleTypeTitleKey = selectedFilters.type?.length === 1 ? TYPE_TITLE_KEYS[selectedFilters.type[0]] : undefined;

  if (!filterNames.length && !singleTypeTitleKey) {
    return t('catalog.allProgramsAndCourses');
  }

  const endText = singleTypeTitleKey ? t(singleTypeTitleKey) : t('catalog.programs');
  return `${filterNames.length ? filterNames.join(' ') : t('catalog.filters.option.all')} ${endText}`;
}
